<template>
<body>
<Front-Header> </Front-Header>
  <div id="map" class="basemap" style="width:600px; height:600px"></div>
<Front-Footer> </Front-Footer>
</body>
</template>

<script>
import Header from './Front-Header';
import Footer from './Front-Footer';
import mapboxgl from "mapbox-gl";

export default {
	components: {
		"Front-Header": Header,
		"Front-Footer": Footer
	},
 name: "MapboxMap",
 data() {
	return {
		accessToken : "pk.eyJ1IjoiaW50cm9zYnMiLCJhIjoiY2t2MHU4bWE4M2h1OTMwczcxMm03YmM0eSJ9.ocDaQEjuvL3rUd50oaB6Qw",
		center: [-93.1247, 44.9323], // St. Paul
		zoom: 2
	};
 },
 mounted() {
   // create the map after the component is mounted
   this.createMap();
 },
 methods: {
	createMap() {
		const stores = {
			"type": "FeatureCollection",
			"features": [{
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.034084142948,
						38.909671288923
					]
				},
				"properties": {
					"phoneFormatted": "(202) 234-7336",
					"phone": "2022347336",
					"address": "1471 P St NW",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "at 15th St NW",
					"postalCode": "20005",
					"state": "D.C."
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.049766,
						38.900772
					]
				},
				"properties": {
					"phoneFormatted": "(202) 507-8357",
					"phone": "2025078357",
					"address": "2221 I St NW",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "at 22nd St NW",
					"postalCode": "20037",
					"state": "D.C."
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.043929,
						38.910525
					]
				},
				"properties": {
					"phoneFormatted": "(202) 387-9338",
					"phone": "2023879338",
					"address": "1512 Connecticut Ave NW",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "at Dupont Circle",
					"postalCode": "20036",
					"state": "D.C."
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.0672,
						38.90516896
					]
				},
				"properties": {
					"phoneFormatted": "(202) 337-9338",
					"phone": "2023379338",
					"address": "3333 M St NW",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "at 34th St NW",
					"postalCode": "20007",
					"state": "D.C."
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.002583742142,
						38.887041080933
					]
				},
				"properties": {
					"phoneFormatted": "(202) 547-9338",
					"phone": "2025479338",
					"address": "221 Pennsylvania Ave SE",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "btwn 2nd & 3rd Sts. SE",
					"postalCode": "20003",
					"state": "D.C."
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-76.933492720127,
						38.99225245786
					]
				},
				"properties": {
					"address": "8204 Baltimore Ave",
					"city": "College Park",
					"country": "United States",
					"postalCode": "20740",
					"state": "MD"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.097083330154,
						38.980979
					]
				},
				"properties": {
					"phoneFormatted": "(301) 654-7336",
					"phone": "3016547336",
					"address": "4831 Bethesda Ave",
					"cc": "US",
					"city": "Bethesda",
					"country": "United States",
					"postalCode": "20814",
					"state": "MD"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.359425054188,
						38.958058116661
					]
				},
				"properties": {
					"phoneFormatted": "(571) 203-0082",
					"phone": "5712030082",
					"address": "11935 Democracy Dr",
					"city": "Reston",
					"country": "United States",
					"crossStreet": "btw Explorer & Library",
					"postalCode": "20190",
					"state": "VA"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.10853099823,
						38.880100922392
					]
				},
				"properties": {
					"phoneFormatted": "(703) 522-2016",
					"phone": "7035222016",
					"address": "4075 Wilson Blvd",
					"city": "Arlington",
					"country": "United States",
					"crossStreet": "at N Randolph St.",
					"postalCode": "22203",
					"state": "VA"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-75.28784,
						40.008008
					]
				},
				"properties": {
					"phoneFormatted": "(610) 642-9400",
					"phone": "6106429400",
					"address": "68 Coulter Ave",
					"city": "Ardmore",
					"country": "United States",
					"postalCode": "19003",
					"state": "PA"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-75.20121216774,
						39.954030175164
					]
				},
				"properties": {
					"phoneFormatted": "(215) 386-1365",
					"phone": "2153861365",
					"address": "3925 Walnut St",
					"city": "Philadelphia",
					"country": "United States",
					"postalCode": "19104",
					"state": "PA"
				}
			}, {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [-77.043959498405,
						38.903883387232
					]
				},
				"properties": {
					"phoneFormatted": "(202) 331-3355",
					"phone": "2023313355",
					"address": "1901 L St. NW",
					"city": "Washington DC",
					"country": "United States",
					"crossStreet": "at 19th St",
					"postalCode": "20036",
					"state": "D.C."
				}
			}]
		};
		stores.features.forEach(function (store, i) {
		  store.properties.id = i;
		});
		this.map = new mapboxgl.Map({
			accessToken: this.accessToken,
			container: "map",
			style: "mapbox://styles/introsbs/ckv9ab7su0ysp14rnnfaevra7",
			minzoom: 1,
			center: this.center,
			zoom: this.zoom,
			hash: false
		});
		this.map.on("move", () => {
			this.center = this.map.getCenter();
		});
		this.map.on("zoom", () => {
			this.zoom = this.map.getZoom();
		});
		this.map.on('load', () => {
			this.map.addLayer({
				id: 'locations',
				type: 'circle',
				source: {
					type: 'geojson',
					data: stores
				}
			});
		});		
	}
 }
};
</script>

